import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Invoice } from '../types/invoice';
import { EnvService } from '../services/env.service';

//const BASE_URL = "http://localhost:3000/invoices"; 
const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {


  constructor(private http: HttpClient,private env: EnvService ) { }


  getJobNo(id) :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/invoices/getJobNo/${id}`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

  getMaxId(id) :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/invoices/getMaxId/${id}`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }
     getReturnNo() :Observable <any[]>{
      return this.http.get<any[]>(`${this.env.apiUrl}/invoices/getReturnNo`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

   getAll():Observable <any[]> {
    return this.http.get <any[]>(`${this.env.apiUrl}/invoices`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getAllWithPagination(pageNo:number,pageSize:number,status : string,searchKey : string):Observable <any> {
      let params = new HttpParams();
      params = params.append('pageNo',String(pageNo));
      params = params.append('pageSize',String(pageSize));
      params = params.append('status',String(status));
      params = params.append('searchKey',String(searchKey));

     return this.http.get <any>(`${this.env.apiUrl}/invoices/pagination`,{params,headers: new HttpHeaders({'Content-Type':'application/json'})})
     .pipe(catchError(this.handleError));
        
     }

     

    getAllQtySales():Observable <any[]> {
      return this.http.get <any[]>(`${this.env.apiUrl}/invoices/getAllQtySales`,httpOptions)
      .pipe(catchError(this.handleError));
         
    }

    getAllTarget(month):Observable <any[]> {
      return this.http.get <any[]>(`${this.env.apiUrl}/invoices/getAllTarget/${month}`,httpOptions)
      .pipe(catchError(this.handleError));
         
    }
   

    getInvoice(invoiceNo):Observable <any> {
      return this.http.get<any>(`${this.env.apiUrl}/invoices/${encodeURIComponent(invoiceNo)}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }


    addInvoice(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    updateInvoice(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/update`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }
    
    addCreditNote(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/creditNote`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    deleteInvoice(data,invoiceNo) : Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/${encodeURIComponent(invoiceNo)}`,data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteCreditNote(data,invoiceNo) : Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/creditNote/${invoiceNo}`,data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       



}
